import React, { useState, useEffect, memo, useMemo } from "react";
import styles from "./loyaltyCopy.module.scss";
import cn from "classnames";
import { LABEL, CUSTOM_MESSAGES } from "../../veriables";
import Modal from "@components/common/Modal";
import { connect } from "react-redux";
import { flowType } from "@utility/userInfo";
import { TouchableButton, TouchableDiv } from "@components/common/Touchable";
import PropTypes from "prop-types";
import { FormatLoyaltyPhoneNumber } from '@utility/helperFunction';

const OrderLoyaltyOffers = ({
  getLoyaltyOffers,
  handleLoyaltyNotNow,
  loyaltyRes,
  loyaltyType,
  accountLookup,
  clearLoyalty,
  deleteLoyalty,
  groupedLoyaltyOfferData,
  offer,
  serverAppTheme,
  isLandScape,
  seat,
  currentSeatId,
}) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [selectedOffer, setSelectedOffer] = useState([]);
  const [isDeleteLoyalty, setIsDeleteLoyalty] = useState(false);
  const [offerOrReward, setOfferOrReward] = useState("");
  const isServerApp = flowType() === "serverApp";

  const groupedLoyaltyOffersData = offer || groupedLoyaltyOfferData;

  const currentSeat = useMemo(
    () => seat?.seats?.find(el => el.id === currentSeatId),
    [seat?.seats, currentSeatId]
  );

  const setSelectedOfferIndex = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };
  
  const handleOfferSelection = (item, index) => {
    setSelectedOfferIndex(index);
    if (selectedOffer.some((d) => d.offerId === item.offerId)) {
      setSelectedOffer([]);
    } else {
      setSelectedOffer([item]);
    }
  };

  useEffect(() => {
    if (loyaltyType === 3) {
      getLoyaltyOffers();
    }
  }, [loyaltyType]);

  useEffect(() => {
    if (
      Object.values(groupedLoyaltyOffersData)?.length > 0 &&
      groupedLoyaltyOffersData.hasOwnProperty("REWARDS") &&
      groupedLoyaltyOffersData.hasOwnProperty("OFFERS")
    ) {
      setOfferOrReward("OFFERS");
    }
  }, [groupedLoyaltyOffersData]);

  const getDistributedOfferReward = (offers, offerOrReward) => {
    if (!offers || offerOrReward === "") return offers;
    return offers.filter((e) => e.groupName === offerOrReward);
  };

  const shouldShowOfferValue = (item) =>
    item?.showAsQuantity ? Number(item?.quantity) > 0 : Number(item?.value) > 0;

  const getOfferValueText = (item) =>
    item?.showAsQuantity
      ? `${LABEL().OLS_QUANTITY}: ${Math.trunc(Number(item?.quantity) || 0)}`
      : `${LABEL().OLS_VALUE}: ${LABEL().CURRENCY_SYMBOL}${(Number(item?.value) || 0).toFixed(2)}`;

  const ClearLoyalty = (seatId) => {
    deleteLoyalty(seatId)();
    handleLoyaltyNotNow(false)
  }

  return (
      <>
        {/* 1. welcome */}
        {!isLandScape && loyaltyRes && (
          <div className="col-12 px-0 position-relative d-flex justify-content-center">
            <div className="col-12 text-center px-0">
              <div className="fs_20 ">
                <b>
                  {LABEL().OLS_WELCOME_BACK}
                  {accountLookup?.firstName ||
                    accountLookup?.lastName ||
                    loyaltyRes?.firstName ||
                    loyaltyRes?.lastName}
                </b>
              </div>
            </div>
          </div>
        )}
        
        {(currentSeat?.loyalty?.guestName || currentSeat?.loyalty?.displayAccountNumber) && (
          <>
            <div className="pt-3"></div>
            <div 
              className={cn(
                "d-flex justify-content-between align-items-center mb-3 mx-3 p-2 fs_12 fw-400 rounded"
              )}
              style={{
                background: serverAppTheme?.checkDetail_tabs,
                color: serverAppTheme?.primary_text,
                minHeight: '40px'
              }}
            >
              <div className="text-left">
                {currentSeat?.loyalty?.guestName && (
                  <span className="fs_16 fw-600" style={{ color: serverAppTheme?.primary_text }}>
                    {currentSeat.loyalty.guestName}
                  </span>
                )}
              </div>
              <div className="text-right">
                {currentSeat?.loyalty?.displayAccountNumber && (
                  <span className="fs_16 fw-600" style={{ color: serverAppTheme?.primary_text }}>
                    {FormatLoyaltyPhoneNumber(currentSeat.loyalty.displayAccountNumber)}
                  </span>
                )}
              </div>
            </div>
          </>
        )}

        {Object.values(groupedLoyaltyOffersData)?.length > 0 &&
          groupedLoyaltyOffersData.hasOwnProperty("REWARDS") &&
          groupedLoyaltyOffersData.hasOwnProperty("OFFERS") && (
            <div className="d-flex justify-content-between">
              <button
                type="button"
                className="btn w-100 my-1  btn-ripple mr-1"
                disabled={offerOrReward !== "OFFERS"}
              >
                <TouchableDiv
                  className={cn(styles.divForPayment)}
                  style={{ fontSize: isServerApp ? "2rem" : "15px" }}
                  role="button"
                  tabIndex="0"
                  onClick={() => setOfferOrReward("OFFERS")}
                >
                  {LABEL().OFFERS}
                </TouchableDiv>
              </button>
              <button
                type="button"
                className="btn w-100 my-1  btn-ripple ml-1"
                disabled={offerOrReward !== "REWARDS"}
              >
                <TouchableDiv
                  className={cn(styles.divForPayment)}
                  style={{ fontSize: isServerApp ? "2rem" : "15px" }}
                  role="button"
                  tabIndex="0"
                  onClick={() => setOfferOrReward("REWARDS")}
                >
                  {LABEL().REWARDS}
                </TouchableDiv>
              </button>
            </div>
          )}
        {/* 2. offers */}
        <div
          className={cn(
            "overflowY",
            Object.values(groupedLoyaltyOffersData)?.length !== 0 &&
              !isLandScape
              ? "h-43 pt-2"
              : "px-3 mt-3",
          )}
          style={{
            height: (currentSeat?.loyalty?.guestName || currentSeat?.loyalty?.displayAccountNumber) ? "65%" : "75%",
          }}
        >
          {/* 2.1. no offers */}
          {Object.values(groupedLoyaltyOffersData)?.length === 0 && (
            <div
              className="h-100 d-flex justify-content-center align-items-center fw-600 fs_32 text-center"
              style={{
                color: serverAppTheme?.primary_text,
              }}
            >
              {LABEL().OLS_NO_OFFERS}
            </div>
          )}
          {/* 2.2. offers */}
          {Object.values(groupedLoyaltyOffersData)?.length > 0 &&
            Object.values(groupedLoyaltyOffersData)?.map(
              ({ groupName, offers }, i) => {
                return (
                  <>
                    {getDistributedOfferReward(offers, offerOrReward)?.map(
                      (item, index) => {
                        return (
                          <TouchableDiv
                            className={cn(
                              styles.offersBox,
                              "row mx-0 mb-2 p-2 col-12",
                            )}
                            onClick={() =>
                              handleOfferSelection(item, `${i}-${index}`)
                            }
                            disabled
                            role="presentation"
                            style={{
                              background:
                                activeIndex === `${i}-${index}`
                                  ? serverAppTheme?.selected
                                  : serverAppTheme?.tip_tile,
                              border: `1px solid ${serverAppTheme?.coupon_tile_border}`,
                              color:
                                activeIndex === `${i}-${index}`
                                  ? "black"
                                  : serverAppTheme?.primary_text,
                            }}
                          >
                            <div
                              className={cn(
                                "fs-16 px-2 text-break text-left",
                                item.imageUrl ? "col-8" : "col-12",
                              )}
                            >
                              <div className="w-100 px-1 fs_16 fw-normal">
                                {item.name}
                              </div>
                              {item.imageUrl === null ? (
                                !shouldShowOfferValue(item) ? (
                                  <></>
                                ) : (
                                  <div className="fs_14 w-100 py-1 ">
                                    {getOfferValueText(item)}
                                  </div>
                                )
                              ) : (
                                <></>
                              )}
                              {item.description && (
                                <div
                                  className="fs-18 fw-normal py-1 text-left"
                                  id="text"
                                >
                                  {item.description}
                                </div>
                              )}
                            </div>
                            {item?.imageUrl && (
                              <div
                                className={cn(
                                  "p-0 text-center",
                                  !isLandScape ? "col-3" : "col-2",
                                )}
                              >
                                {item.imageUrl !== null ? (
                                  !shouldShowOfferValue(item) ? (
                                    <></>
                                  ) : (
                                    <div
                                      className="text-center fs-16 w-100 py-1 fw-500"
                                      style={{
                                        color:
                                          activeIndex === `${i}-${index}`
                                            ? "black"
                                            : serverAppTheme?.coupon_points,
                                      }}
                                    >
                                      {getOfferValueText(item)}
                                    </div>
                                  )
                                ) : (
                                  <></>
                                )}
                                <img
                                  className={cn("img-build", styles.imgOffer)}
                                  src={item.imageUrl}
                                  alt=""
                                  style={{ borderRadius: "12px" }}
                                />
                              </div>
                            )}
                          </TouchableDiv>
                        );
                      },
                    )}
                    {(!offers || offers?.length === 0) && (
                      <>
                        {" "}
                        <div
                          className="d-flex text-center justify-content-center align-items-center h-100 fs-22"
                          style={{ color: serverAppTheme?.noRecord }}
                        >
                          {LABEL().OS_NO_OFFERS}
                        </div>{" "}
                      </>
                    )}
                  </>
                );
              },
            )}
        </div>
        {/* 3. button */}
        <div 
          className={cn("col-12 row d-flex justify-content-center pr-0", Object.values(groupedLoyaltyOffersData)?.length > 0 && "position-absolute")}
          style={{bottom: Object.values(groupedLoyaltyOffersData)?.length > 0 && "16px"}}
        >
          {/* 3.1. common button */}
          <TouchableDiv
            className={cn(
              "px-0 mx-0 text-center fw-600 mb-2",
              !isLandScape ? "fs_28 col-12" : "fs_24 col-4 ",
            )}
            role="button"
            tabIndex="0"
            onClick={(e) => {e.preventDefault(); ClearLoyalty()}}
          >
            <small
              style={{
                textDecoration: "underline",
                color: serverAppTheme?.NO_RECEIPT,
              }}
            >
              {LABEL().OLS_CLEAR_ACCOUNT}
            </small>
          </TouchableDiv>

          <TouchableDiv
            className={cn(
              "px-0 mx-0 text-center fw-600 mb-2",
              !isLandScape ? "fs_28 col-12" : "fs_24 col-4 ",
            )}
            role="button"
            tabIndex="0"
            onClick={deleteLoyalty(currentSeatId)}
          >
            <small
              style={{
                textDecoration: "underline",
                color: serverAppTheme?.NO_RECEIPT,
              }}
            >
              {LABEL().OLS_CHANGE_ACCOUNT}
            </small>
          </TouchableDiv>
          {/* 3.2. offer button */}
          {Object.values(groupedLoyaltyOffersData)?.length > 0 && (
            <div
              className={cn(
                "px-0 mx-auto d-flex justify-between",
                !isLandScape ? "col-12" : "col-7 ",
              )}
            >
              <div className="col-12 pl-0 pr-1 d-flex align-items-end">
                <TouchableButton
                  type="button"
                  className={cn(
                    styles.loyalty_btn,
                    "col-12 px-0 btn btn-ripple od-primary-btn-bg-color od-primary-btn-font-color",
                  )}
                  onClick={(event) => {
                    event.preventDefault();
                    handleLoyaltyNotNow(false);
                  }}
                  style={{ height: "7.5vh" }}
                  rippleEffect={true}
                >
                  <div
                    className={cn("fw-600", !isLandScape ? "fs_32" : "fs_24")}
                  >
                    {LABEL().OLS_CONTINUE}
                  </div>
                </TouchableButton>
              </div>
            </div>
          )}
        </div>
        {/* 3.3. no offers button */}
        {Object.values(groupedLoyaltyOffersData)?.length === 0 && (
          <div className="col-6 pl-0 pr-0 d-flex align-items-end mb-1 mx-auto">
            <TouchableButton
              type="button"
              className={cn(styles.loyalty_btn, "col-12 px-0 btn btn-ripple od-primary-btn-bg-color od-primary-btn-font-color")}
              onClick={(event) => {
                event.preventDefault();
                handleLoyaltyNotNow();
              }}
              style={{ height: "7.5vh" }}
              rippleEffect={true}
            >
              <div className={cn("fs_24 fw-600")}>{LABEL().OLS_CONTINUE}</div>
            </TouchableButton>
          </div>
        )}
      
      {isDeleteLoyalty && (
        <Modal
          isOpen={isDeleteLoyalty}
          isModalCenter
          customClass2={cn("h-98")}
          style={{
            height: "98%",
            width: "480px",
            margin: "auto",
            backgroundColor: serverAppTheme?.popUp_bg,
            minHeight: "222px",
            borderRadius: "16px",
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
          }}
        >
          <div
            className="col-12 p-2 d-flex flex-column mx-0 fs-18 justify-content-center align-items-center "
            style={{ color: serverAppTheme?.primary_text }}
          >
            <div className="py-2 fs-34 fw-600 text-center">Are You Sure?</div>
            <div
              className="px-4 text-center my-3  fs-26 fw-600 "
              style={{ fontFamily: "Poppins" }}
            >
              {CUSTOM_MESSAGES().DELETE_LOYALTY_ACCOUNT}
            </div>
            <div
              className="d-flex pr-3 position-fixed"
              style={{ width: "88%", bottom: "4%" }}
            >
              <TouchableButton
                type="button"
                onClick={(event) => {
                  event.preventDefault();
                  setIsDeleteLoyalty(false);
                }}
                className={cn(
                  styles.loyalty_btn,
                  "col-6 m-1 py-2 rounded border-0  btn-ripple fs-30 fw-600",
                )}
                style={{ height: "68px" }}
              >
                {LABEL().NO}
              </TouchableButton>
              <TouchableButton
                type="submit"
                onClick={(event) => {
                  event.preventDefault();
                  setIsDeleteLoyalty(false);
                  deleteLoyalty(currentSeatId)();
                }}
                className={cn(
                  "col-6 m-1 py-2 rounded btn-ripple  opacity-75 fs-30 fw-600",
                  styles.coupon_btn,
                )}
                style={{
                  background: serverAppTheme?.OFF_Premise_Btn,
                  border: serverAppTheme?.cancleBtn_Border,
                  color: serverAppTheme?.cancleBtn_font,
                }}
              >
                {LABEL().DELETE}
              </TouchableButton>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

const mapStateToProps = ({ loyalty }) => ({
  offer: loyalty?.orderLoyaltyOffersData,
});

OrderLoyaltyOffers.propTypes = {
  getLoyaltyOffers: PropTypes.func,
  handleLoyaltyNotNow: PropTypes.func,
  handleApplyOffer: PropTypes.func,
  clearLoyalty: PropTypes.func,
  deleteLoyalty: PropTypes.func,

  loyaltyRes: PropTypes.object,
  loyaltyType: PropTypes.number,
  accountLookup: PropTypes.object,
  groupedLoyaltyOfferData: PropTypes.object,
  offer: PropTypes.object,

  isLandScape: PropTypes.bool,
  noOfferSelectedPopUp: PropTypes.bool,

  seat: PropTypes.shape({
    seats: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        loyalty: PropTypes.shape({
          guestName: PropTypes.string,
          displayAccountNumber: PropTypes.string,
        }),
      })
    ),
  }),

  serverAppTheme: PropTypes.shape({
    primary_text: PropTypes.string,
    checkDetail_tabs: PropTypes.string,
    selected: PropTypes.string,
    tip_tile: PropTypes.string,
    coupon_tile_border: PropTypes.string,
    coupon_points: PropTypes.string,
    noRecord: PropTypes.string,
    NO_RECEIPT: PropTypes.string,

    popUp_bg: PropTypes.string,
    popUp_box_shadow: PropTypes.string,
    popupBorder: PropTypes.string,

    OFF_Premise_Btn: PropTypes.string,
    cancleBtn_Border: PropTypes.string,
    cancleBtn_font: PropTypes.string,
  }),
};

OrderLoyaltyOffers.defaultProps = {
  getLoyaltyOffers: () => {},
  handleLoyaltyNotNow: () => {},
  handleApplyOffer: () => {},
  clearLoyalty: () => {},
  deleteLoyalty: () => {},

  loyaltyRes: null,
  loyaltyType: null,
  accountLookup: null,
  groupedLoyaltyOfferData: {},
  offer: null,

  isLandScape: false,
  noOfferSelectedPopUp: false,
  seat: null,

  serverAppTheme: {
    primary_text: "",
    checkDetail_tabs: "",
    selected: "",
    tip_tile: "",
    coupon_tile_border: "",
    coupon_points: "",
    noRecord: "",
    NO_RECEIPT: "",
    popUp_bg: "",
    popUp_box_shadow: "",
    popupBorder: "",
    OFF_Premise_Btn: "",
    cancleBtn_Border: "",
    cancleBtn_font: "",
  },
};

const MemoisedLoyaltyOffers = memo(OrderLoyaltyOffers);
export default connect(mapStateToProps, null)(MemoisedLoyaltyOffers);
